import { toTimestamp } from '@mi-front/core';

export const getThreeTranscriptionWords = (arr: any[], ts: number) => {
  if (arr && arr.length) {
    const index = arr.findIndex(
      (data) =>
        toTimestamp(data?.start as unknown as number) <= ts &&
        toTimestamp(data?.end as unknown as number) >= ts,
    );

    if (index === -1 || index + 2 >= arr.length) {
      return null;
    }

    return arr
      .slice(index, index + 3)
      .map((w: { time: number; word: string }) => w.word)
      .join('');
  }
  return null;
};
